import { render } from "./ChatBot.vue?vue&type=template&id=e0363c22&scoped=true"
import script from "./ChatBot.vue?vue&type=script&lang=js"
export * from "./ChatBot.vue?vue&type=script&lang=js"

import "../assets/css/ChatBot.css?vue&type=style&index=0&id=e0363c22&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0363c22"]])

export default __exports__